<section class="admin-page ct-page">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'specs.subtitle' | t }}</p>
    </div>
  </div>

  <div class="grid">
    <aside class="ct-card panel">
      <h3>{{ 'specs.leafCategory' | t }}</h3>
      <div class="list">
        @for (cat of leafCategories(); track cat.id) {
          <button
            type="button"
            class="list-item"
            [class.active]="selectedCategoryId() === cat.id"
            (click)="selectCategory(cat.id)"
          >
            <strong>{{ cat.name }}</strong>
            <small>{{ cat.parentName }}</small>
          </button>
        } @empty {
          <p class="empty">{{ 'specs.noLeaf' | t }}</p>
        }
      </div>
    </aside>

    <div class="stack">
      <div class="ct-card panel">
        <h3>{{ (editingId() ? 'specs.edit' : 'specs.new') | t }}</h3>
        <form class="form-row" [formGroup]="form" (ngSubmit)="save()">
          <div class="ct-field grow">
            <label for="tagName">{{ 'common.name' | t }}</label>
            <input id="tagName" class="ct-input" formControlName="name" />
          </div>
          <div class="actions">
            @if (editingId()) {
              <button class="ct-btn ct-btn-ghost" type="button" (click)="openCreate()">
                {{ 'common.cancel' | t }}
              </button>
            }
            <button class="ct-btn ct-btn-primary" type="submit">{{ 'common.save' | t }}</button>
          </div>
        </form>
      </div>

      <div class="ct-card panel">
        <div class="panel__head">
          <h3>{{ 'specs.catalog' | t }}</h3>
          @if (tags().length) {
            <button class="ct-btn ct-btn-primary ct-btn-sm" type="button" (click)="saveOrder()">
              {{ 'specs.saveOrder' | t }}
            </button>
          }
        </div>

        <div class="chips">
          @if (loading()) {
            <p class="empty">{{ 'common.loading' | t }}</p>
          } @else if (tags().length === 0) {
            <p class="empty">{{ 'specs.empty' | t }}</p>
          } @else {
            @for (tag of tags(); track tag.id; let i = $index) {
              <div class="chip">
                <div class="chip__order">
                  <button
                    type="button"
                    class="order-btn"
                    [disabled]="i === 0"
                    (click)="moveTag(i, -1)"
                    [attr.aria-label]="'specs.moveUp' | t"
                    [attr.title]="'specs.moveUp' | t"
                  >
                    ↑
                  </button>
                  <button
                    type="button"
                    class="order-btn"
                    [disabled]="i === tags().length - 1"
                    (click)="moveTag(i, 1)"
                    [attr.aria-label]="'specs.moveDown' | t"
                    [attr.title]="'specs.moveDown' | t"
                  >
                    ↓
                  </button>
                </div>
                <div class="chip__body">
                  <strong>{{ tag.name }}</strong>
                </div>
                <div class="row-actions">
                  <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openEdit(tag)">
                    {{ 'common.edit' | t }}
                  </button>
                  <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="remove(tag)">
                    {{ 'common.delete' | t }}
                  </button>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</section>
